export const MARRIED = "1";
export const SEPARATED = "2";
export const UNMARRIED = "3";

export default Object.freeze({
  [MARRIED]: "Married",
  [SEPARATED]: "Separated",
  [UNMARRIED]: "Unmarried"
});
